import React from "react";
import { Grid, Popup } from "semantic-ui-react";
import uuid from "react-uuid";
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";
import Utils from "../util/Utils";

const SectorRow = ({ sector, quotesBySector, onClick }) => {
  const getEmptyGrids = (len) => {
    return Array.from({ length: len }, () => (
      <Grid.Column
        key={uuid()}
        style={{ backgroundColor: "white" }}
        padded="horizontally"
      />
    ));
  };

  const len = quotesBySector.length;
  const emptyCells = len <= 12 ? 12 - len : (12 - ((len - 12) % 12)) % 12; // ensures emptyCells is 0 when divisible

  return (
    <>
      <Grid.Column
        padded="horizontally"
        width={3}
        style={{ backgroundColor: "#495674", color: "white" }}
        textAlign="left"
      >
        <h4>{sector}</h4>
      </Grid.Column>

      {quotesBySector.map((item, index) => {
        const cell = (
          <Grid.Column
            key={item.symbol}
            style={{
              cursor: "pointer",
              color: "white",
              backgroundColor: Utils.getCellBackGroundColor(item.changesColor),
            }}
            onClick={() => onClick(item.symbol)}
          >
            <Popup inverted trigger={<p>{item.symbol}</p>} size="large">
              <Popup.Header>
                {item.name}
                <br />
                {Utils.format_currency_usd(item.price)}
              </Popup.Header>
              <Popup.Content>
                {Utils.format_currency_usd(item.change)} (
                {item.changesPercentage}%)
              </Popup.Content>
            </Popup>
          </Grid.Column>
        );

        return index > 0 && index % 12 === 0 ? (
          <React.Fragment key={uuid()}>
            <Grid.Column
              padded="horizontally"
              width={3}
              style={{ backgroundColor: "#495674" }}
            />
            {cell}
          </React.Fragment>
        ) : (
          cell
        );
      })}

      {getEmptyGrids(emptyCells)}
    </>
  );
};

export default SectorRow;
